import CustomerView from 'models/location/customer_view';

export default function(context, { customerId, conversationId, conversationItemId }) {
  context.router.navigateTo(
    CustomerView.create({
      customerId,
      currentConversationId: conversationId,
      currentConversationItemId: conversationItemId,
    })
  );
}
